import { FilterSearchingBaseViewModel, PagingResultsViewModel } from 'src/app/components/core/_infrastructure/types/common';

export class TwAforoViewModel {
    // Campos de la tabla TwAforoCultivoCam
    public Id: number | null;
    public IdCultivo: number;
    public Anyo: number;
    public Descripcion: string;
    public KgsProduccionEstimada: number;
    public KgsProduccionReal: number;
    public IdUsuario: number;
    public FechaCreacion: Date;
    public Mes: number;

    // Campos necesarios para el Mantenimiento de Aforos que vienen de otras tablas
    public IdRecinto: number;
    public TitularRecinto: string;
    public IdentificadorCultivo: string;
    public IdComunidadAutonoma: number;
    public IdComunidadAutonomaDescripcion: string;
    public IdProvincia: number;
    public IdProvinciaDescripcion: string;
    public IdVariedad: number;
    public IdVariedadDescripcion: string;
}

export class AforoItemResultsViewModel extends PagingResultsViewModel {
    public ResultList: AforoItemViewModel[];
}
export class AforoItemViewModel {
    public Id: number; // Id del Aforo
    public IdComunidadAutonomaDescripcion: string;
    public IdProvinciaDescripcion: string;
    public TitularRecinto: string;
    public IdVariedadDescripcion: string;
    public Descripcion: string;
    public Anyo: number;
    public Mes: number;
    public KgsProduccionEstimada: number;
    public KgsProduccionReal: number;
}

export class FilterSearchingTwAforoViewModel extends FilterSearchingBaseViewModel {
    public IdComunidadAutonoma: number | null;
    public IdProvincia: number | null;
    public IdRecinto: number | null;
    public IdCultivo: number | null;
    public IdVariedad: number | null;
    public Anyo: number | null;
    public Descripcion: string;
}
